import { useEffect, useMemo, useState } from "react";
import { getShiftRequestAccesptJobs } from "../../slice/workerResumeSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const WorkerAcceptedJobs = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const { shiftRequestAcceptJobs, loading, error } = useSelector(
        (state) => state.workerResume
    );

    useEffect(() => {
        if (!token) return;
        dispatch(getShiftRequestAccesptJobs(token));
    }, [dispatch, token]);

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case "accepted":
                return "bg-success";
            case "declined":
                return "bg-warning text-dark";
            default:
                return "bg-secondary";
        }
    };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Accepted Shift Request
                    </h4>

                    {/* 🔄 Loading */}
                    {loading && (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* ❌ Error */}
                    {!loading && error && (
                        <div className="alert alert-danger text-center">
                            {error}
                        </div>
                    )}

                    {!loading && !error && (
                        shiftRequestAcceptJobs.length > 0 ? (
                            shiftRequestAcceptJobs.map((job) => (
                                <div className="card shadow-sm mb-4 border-0 rounded-3" key={job.id}>
                                    <div className="card-body p-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* Title */}
                                            <h5 className="text-primary fw-bold mb-3" style={{ fontSize: "1.25rem" }}>
                                                {job.title || "Shift Job Request"}
                                            </h5>

                                            <p>
                                                <span className={`badge ${getStatusClass(job.status)} text-uppercase`}>{job.status}</span>
                                            </p>


                                        </div>
                                        {/* Location */}
                                        <p className="mb-3">
                                            <strong className="me-2">📍 Location:</strong>
                                            <span className="text-dark">{job.city}, {job.state}, {job.country}</span>
                                        </p>

                                        {/* Salary Type / Ratio */}
                                        <p className="mb-3">
                                            <strong className="me-2">⚖️ Salary Type:</strong>
                                            <span className="badge bg-info text-dark">{job.ratio || "Hourly"}</span>
                                        </p>

                                        {/* Dates */}
                                        <p className="mb-3">
                                            <strong className="me-2">📅 Date:</strong>
                                            <span className="text-dark">
                                                {job.start_date}{job.end_date && ` - ${job.end_date}`}
                                            </span>
                                        </p>

                                        {/* Timings */}
                                        <p className="mb-3">
                                            <strong className="me-2">🕒 Working Timings:</strong>
                                            <span className="text-dark">
                                                {job.start_time}{job.end_time && ` - ${job.end_time}`}
                                            </span>
                                        </p>

                                        <button
                                            className="btn btn-light-header"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/panel/shift-request-logs/${job.id}`)
                                            }}
                                        >
                                            Details
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-muted text-center">
                                No shift accepted jobs found.
                            </p>
                        )
                    )}
                </div>
            </div>
        </>
    );
};

export default WorkerAcceptedJobs;